import styled from "styled-components";

export const StyledConfirmBtnContainer = styled.div`
    margin-top: auto;
    position: sticky;
    bottom: 0;
`;
